<script>
  let { kind, name, desc, label, onclick } = $props();
</script>

<button class="tile" {onclick} aria-label={label}>
  <span class="well">
    {#if kind === 'sakura'}
      <span class="avatar avatar-sakura" aria-hidden="true">
        <span class="branch"></span>
        {#each Array(7) as _, i (i)}
          <span class="petal" style={`--i:${i}`}></span>
        {/each}
      </span>
    {:else}
      <span class="avatar avatar-ocean" aria-hidden="true">
        <span class="moon"></span>
        <span class="wave wave-back"></span>
        <span class="wave wave-mid"></span>
        <span class="wave wave-front"></span>
        {#each Array(4) as _, i (i)}
          <span class="sparkle" style={`--i:${i}`}></span>
        {/each}
      </span>
    {/if}
  </span>
  <span class="tile-name">{name}</span>
  <span class="tile-desc">{desc}</span>
</button>

<style>
  /* ===== Chunky 3D-beveled tile ===== */
  .tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    min-width: 132px;
    padding: 14px 20px 12px;
    cursor: pointer;
    color: var(--text, #edf1f5);
    font-family: inherit;
    font-size: inherit;
    background:
      repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.03) 0 6px,
        rgba(0, 0, 0, 0.05) 6px 12px
      ),
      linear-gradient(to bottom, #596463, #3a4342);
    border: 2px solid;
    border-color: var(--bevel-light, #8b9694) var(--bevel-dark, #1a201f) var(--bevel-dark, #1a201f)
      var(--bevel-light, #8b9694);
    outline: 1px solid var(--bevel-outline, #000);
    image-rendering: pixelated;
    transform: translateZ(0);
    transform-origin: center bottom;
    box-shadow:
      inset 1px 1px 0 rgba(255, 255, 255, 0.3),
      inset -2px -2px 0 rgba(0, 0, 0, 0.45),
      2px 3px 0 rgba(0, 0, 0, 0.5),
      4px 6px 0 rgba(0, 0, 0, 0.3),
      0 8px 14px rgba(0, 0, 0, 0.45);
    transition:
      transform 0.18s cubic-bezier(0.34, 1.4, 0.64, 1),
      box-shadow 0.18s ease,
      background 0.12s ease;
  }
  .tile:hover {
    background:
      repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.05) 0 6px,
        rgba(0, 0, 0, 0.04) 6px 12px
      ),
      linear-gradient(to bottom, #68746f, #454e4d);
    transform: translateY(-2px) translateZ(14px) rotateX(7deg) scale(1.04);
    box-shadow:
      inset 1px 1px 0 rgba(255, 255, 255, 0.4),
      inset -2px -2px 0 rgba(0, 0, 0, 0.45),
      3px 5px 0 rgba(0, 0, 0, 0.55),
      6px 10px 0 rgba(0, 0, 0, 0.32),
      0 16px 26px rgba(0, 0, 0, 0.55);
  }
  .tile:active {
    background: linear-gradient(to bottom, #303836, #3c4544);
    border-color: var(--bevel-dark, #1a201f) var(--bevel-light, #8b9694) var(--bevel-light, #8b9694)
      var(--bevel-dark, #1a201f);
    transform: translateY(2px) scale(0.98);
    box-shadow:
      inset 2px 3px 4px rgba(0, 0, 0, 0.6),
      inset -1px -1px 0 rgba(255, 255, 255, 0.12),
      0 1px 0 rgba(0, 0, 0, 0.5);
  }
  .tile:focus-visible {
    outline: 2px solid #ffd85a;
    outline-offset: 1px;
    box-shadow:
      inset 1px 1px 0 rgba(255, 255, 255, 0.35),
      inset -2px -2px 0 rgba(0, 0, 0, 0.45),
      0 0 0 4px rgba(255, 216, 90, 0.28),
      3px 5px 0 rgba(0, 0, 0, 0.55),
      0 14px 22px rgba(0, 0, 0, 0.5);
  }

  /* ===== Sunken well framing the avatar ===== */
  .well {
    display: block;
    padding: 3px;
    background: linear-gradient(to bottom, #232928, #39423f);
    border: 2px solid;
    border-color: #171c1b #7e8987 #7e8987 #171c1b;
    outline: 1px solid var(--bevel-outline, #000);
    box-shadow:
      inset 2px 2px 4px rgba(0, 0, 0, 0.75),
      inset -1px -1px 0 rgba(255, 255, 255, 0.14);
  }
  .avatar {
    position: relative;
    display: block;
    width: 68px;
    height: 68px;
    overflow: hidden;
    border: 1px solid #000;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.6);
    image-rendering: pixelated;
  }
  .tile:hover .avatar {
    box-shadow:
      inset 0 0 10px rgba(0, 0, 0, 0.6),
      0 0 10px rgba(255, 216, 90, 0.3);
  }

  /* Guest — drifting sakura petals */
  .avatar-sakura {
    background:
      radial-gradient(circle at 70% 20%, rgba(255, 214, 230, 0.5), transparent 45%),
      linear-gradient(160deg, #3d1030 0%, #7a2450 55%, #c2447e 100%);
  }
  .avatar-sakura .branch {
    position: absolute;
    top: 8px;
    left: -6px;
    width: 46px;
    height: 4px;
    background: #2b1020;
    transform: rotate(14deg);
    border-radius: 2px;
    box-shadow:
      14px 6px 0 -1px #2b1020,
      28px 10px 0 -1px #2b1020;
  }
  .avatar-sakura .petal {
    position: absolute;
    top: -8px;
    left: calc(6px + var(--i) * 9px);
    width: 6px;
    height: 6px;
    background: #ffc7dd;
    border: 1px solid #e893b7;
    border-radius: 60% 0 60% 0;
    animation: petal-fall calc(2.6s + var(--i) * 0.5s) linear infinite;
    animation-delay: calc(var(--i) * -0.7s);
  }
  @keyframes petal-fall {
    0% {
      transform: translate(0, 0) rotate(0deg);
      opacity: 0;
    }
    12% {
      opacity: 1;
    }
    100% {
      transform: translate(-14px, 78px) rotate(240deg);
      opacity: 0.7;
    }
  }

  /* Administrator — night ocean waves */
  .avatar-ocean {
    background:
      radial-gradient(circle at 30% 18%, rgba(215, 235, 255, 0.35), transparent 40%),
      linear-gradient(to bottom, #0a1430 0%, #14306b 60%, #1b4f8f 100%);
  }
  .avatar-ocean .moon {
    position: absolute;
    top: 7px;
    left: 10px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #eef4ff;
    box-shadow: 0 0 10px rgba(238, 244, 255, 0.85);
  }
  .avatar-ocean .wave {
    position: absolute;
    left: -50%;
    width: 200%;
    height: 22px;
    border-radius: 45% 55% 0 0;
  }
  .avatar-ocean .wave-back {
    bottom: 14px;
    background: #2a62a8;
    animation: wave-roll 4.5s ease-in-out infinite;
  }
  .avatar-ocean .wave-mid {
    bottom: 7px;
    background: #1d4d8c;
    animation: wave-roll 3.4s ease-in-out infinite reverse;
  }
  .avatar-ocean .wave-front {
    bottom: 0;
    background: #123566;
    box-shadow: 0 -2px 0 rgba(255, 255, 255, 0.25);
    animation: wave-roll 2.6s ease-in-out infinite;
  }
  @keyframes wave-roll {
    0%,
    100% {
      transform: translateX(-6%) scaleY(1);
    }
    50% {
      transform: translateX(6%) scaleY(1.25);
    }
  }
  .avatar-ocean .sparkle {
    position: absolute;
    top: calc(12px + var(--i) * 9px);
    left: calc(34px + var(--i) * 7px);
    width: 2px;
    height: 2px;
    background: #fff;
    animation: sparkle-blink calc(1.4s + var(--i) * 0.6s) steps(1) infinite;
  }
  @keyframes sparkle-blink {
    0%,
    60%,
    100% {
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
  }

  /* ===== Labels ===== */
  .tile-name {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #f2f6fa;
    text-shadow:
      1px 1px 0 #000,
      2px 2px 0 rgba(0, 0, 0, 0.45);
  }
  .tile-desc {
    font-size: 10px;
    letter-spacing: 0.3px;
    color: var(--text-muted, #9ca6b2);
    text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.6);
  }

  @media (prefers-reduced-motion: reduce) {
    .tile,
    .avatar-sakura .petal,
    .avatar-ocean .wave,
    .avatar-ocean .sparkle {
      animation: none !important;
      transition: none !important;
    }
    .tile:hover {
      transform: none;
    }
  }
</style>
